import StatusService from "@/services/bytepro/status.service";

export const statusApi = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    get({ commit }, fileDataId) {
      return StatusService.get(fileDataId).then(
        (resp) => {
          commit("dummy", "StatusService.get - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "StatusService.get - error");
          return Promise.reject(error.response);
        }
      );
    },
    update({ commit }, { status, fileDataId }) {
      return StatusService.update(status, fileDataId).then(
        (resp) => {
          commit("dummy", "StatusService.update - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "StatusService.update - error");
          return Promise.reject(error.response);
        }
      );
    },
    updateStatusOnly({ commit }, { status, fileDataId }) {
      return StatusService.updateStatusOnly(status, fileDataId).then(
        (resp) => {
          commit("dummy", "StatusService.updateStatusOnly - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "StatusService.updateStatusOnly - error");
          return Promise.reject(error.response);
        }
      );
    },
  },
  mutations: {
    dummy(state, obj) {
      console.log(obj);
    },
  },
};
